/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Activity_EmptyInputs */



/**
* | output |
* | --- |
* | "No plan or member changes recorded." |
*
* @param {Partner_Org_Activity_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_activity_empty = /** @type {((inputs?: Partner_Org_Activity_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Activity_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Tarif- oder Mitgliederänderungen erfasst.")
	return /** @type {LocalizedString} */ ("No plan or member changes recorded.")
});